import client from "../../../api/client";

export default async function getAuthStatusByEmail(email) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  const response = await client.post("/auth/auth-status-by-email", {
    email: normalizedEmail,
  });

  return response.data;
}